import AsideButtons, { AsideButton } from './AsideButtons';
import CopyTableButton   from "@components/AsideButtons/CopyTableButton";
import './AsideButtons.scss';

export default AsideButtons;

export { AsideButton, CopyTableButton };